export default __webpack_public_path__ + "static/media/elec-5.8f071bfc.png";